// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__c1di9","row":"Node_row__3bSI3","label":"Node_label__Z_bcS","footer":"Node_footer__2BMXJ"};